import React, { Component } from "react";
import { Form, Col, Row, Container } from "react-bootstrap";

export default class FormValueOnly extends Component {

  render() {
    return (
      <Container>
        <Form.Group
          controlId={this.props.fieldModel.name}
          key={this.props.index}
          as={Row}
        >
            <Form.Label id={this.props.fieldModel.name} column sm={2} className="dynamicFormLabel">
              {this.props.fieldModel.label}
            </Form.Label>
            <Col sm={10}>
              <Form.Control value={this.props.formData} readOnly plaintext/>
            </Col>
        </Form.Group>
      </Container>
    );
  }
}

